import React from 'react';
import { withFormikFormControl } from '../FormikFormControl';
import DisplayRendering from "../DisplayRendering";
import {useFormikContext} from "formik";


export const Lookup = (props) => {
  const {details, extraConfig = {}} = props
  const {options = {}} = extraConfig
  const {recordLinkFieldId, lookupFieldName} = options
  const {
    values,
    setFieldValue,
  } = useFormikContext();
  const items = (values[recordLinkFieldId] || []).map( rec => rec[lookupFieldName] )
  console.log("LOOKUP FIELD", items, values, props)
  return <DisplayRendering value={items} {...props}/>

};

export const LookupFormik = withFormikFormControl()(Lookup);

export default LookupFormik;
